import { render, staticRenderFns } from "./product-splitter.vue?vue&type=template&id=cbfdf8f4&scoped=true&lang=pug&"
import script from "./product-splitter.vue?vue&type=script&lang=ts&"
export * from "./product-splitter.vue?vue&type=script&lang=ts&"
import style0 from "./product-splitter.vue?vue&type=style&index=0&id=cbfdf8f4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbfdf8f4",
  null
  
)

export default component.exports